const Error = (
    props: React.SVGProps<SVGSVGElement> & { size?: number }
): React.ReactElement => {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_1007_519)">
                <path
                    d="M19.6034 7.23197C19.6034 7.23197 20.9801 4.38751 18.1009 5.57984C15.0015 6.8579 12.8932 10.5596 12.8932 10.5596C12.8932 10.5596 8.51154 5.9695 6.85169 6.5228C5.19184 7.0761 5.82117 8.99319 8.50367 10.9414C11.1862 12.8897 8.543 14.7912 6.26169 16.9966C3.81519 19.3345 5.80543 20.2385 7.24502 19.4047C10.8243 17.3317 11.1783 13.7703 13.2708 15.8432C15.3633 17.9162 16.4175 21.01 18.6909 18.9605C20.9644 16.9109 14.8205 12.8118 14.8205 12.8118C14.8205 12.8118 18.3212 9.52312 19.6034 7.23197Z"
                    fill="#EF8078"
                />
                <path
                    d="M15.8827 0.6C13.3041 0.170097 10.6549 0.491382 8.2571 1.52481C5.8593 2.55825 3.81609 4.25934 2.37576 6.42138C1.48756 7.73679 0.881335 9.21879 0.594607 10.7757C0.307879 12.3325 0.346753 13.9311 0.70882 15.4725C1.07089 17.0139 1.74845 18.4652 2.69956 19.7367C3.65066 21.0083 4.85508 22.0729 6.23826 22.8647C8.84522 24.4528 11.9653 24.9968 14.9629 24.3858C17.9605 23.7748 20.6103 22.0547 22.3726 19.576C28.4614 11.0037 20.1385 2.68073 20.1385 2.68073L12.8777 10.3569L6.94626 4.72251L4.58628 6.81882L10.3761 12.648L4.30309 18.3837L6.24613 20.5501L12.4843 14.8846L18.2348 20.5034L20.4453 18.3837L14.805 12.648C14.805 12.648 16.1659 10.0062 20.9881 7.56696"
                    stroke="#696158"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1007_519">
                    <rect width="25" height="25" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Error
